<template>
  <div>
    <v-row class="py-0">
      <v-col cols="6">
        <h3 class="title dw_green--text font-weight-light">
          <v-icon color="dw_green" class="mr-2 mb-1" v-text="mdiCompassOutline" />
          Add an Objective
        </h3>
        <v-form ref="addObjectiveForm" v-model="formValid" @submit.prevent>
          <v-card flat color="bg_dark">
            <v-card-text class="px-4 py-0">
              <v-text-field
                v-model="newObjective"
                :counter="256"
                placeholder="Add a new objective here *"
                color="dw_green"
                :rules="rules"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                type="button"
                @click="resetForm"
                color="dw_green"
                x-small
                text>Clear</v-btn>
              <v-btn
                type="submit"
                :disabled="!formValid"
                @click="addObjective"
                color="dw_green"
                small
                outlined>
                Add
                <v-icon small color="dw_green" class="ml-1" v-text="mdiCompass" />
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
      <v-col cols="6">
        <objective-list />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mdiCompass, mdiCompassOutline, mdiMagnify } from '@mdi/js';
import { mapActions } from 'vuex';
import objectiveList from '@/components/forms/simpleLists/objectiveList.vue';
import utils from '@/utils/index';

export default {
  name: 'addObjective',
  components: {
    objectiveList
  },
  data() {
    return {
      mdiCompass,
      mdiCompassOutline,
      mdiMagnify,
      formValid: false,
      newObjective: ''
    };
  },
  computed: {
    rules() {
      return [
        utils.validationRules.required,
        utils.validationRules.min,
        utils.validationRules.max,
        utils.validationRules.textRegex
      ];
    }
  },
  methods: {
    ...mapActions([
      'fetchObjectiveOptions',
      'createObjective'
    ]),
    async addObjective() {
      try {
        await this.createObjective({ title: this.newObjective });
        this.fetchObjectiveOptions();
        this.resetForm();
      } catch (err) {
        console.error(err);
      }
    },
    resetForm() {
      this.newObjective = '';
      this.$refs.addObjectiveForm.resetValidation();
    }
  }
};
</script>
